import React, { Component } from 'react'
import Ink from 'react-ink'
import { connect } from 'react-redux'
import { setArticleBaseModal } from '../actions/generalActions'
import PropTypes from 'prop-types'

class ArticleBaseListItem extends Component {
    constructor(props) {
        super(props);
        this.handleTouchTap = this.handleTouchTap.bind(this);
    }

    handleTouchTap() {
        this.props.Callback(this.props.Article);
    }

    render() {
        return (
            <div className="listdiv">
                <button className="articleListItem" onClick={evt => this.handleTouchTap(false)}>
                    <label className="listItemLabelTop">{this.props.Description}</label>
                    {/* <label className="listItemLabel">{this.props.Article.ArticleNumber}</label> */}
                    <Ink />
                </button>
            </div>
        )
    }
}

ArticleBaseListItem.propTypes = {
    Article: PropTypes.object.isRequired,
    //Resolved once by the parent so filtering, sorting, and rendering all agree on the same description.
    Description: PropTypes.string,
    Callback: PropTypes.func
}

export default connect(null, { setArticleBaseModal })(ArticleBaseListItem)


// WEBPACK FOOTER //
// src/components/ArticleBaseListItem.jsx